import { SnMapClusterPoint } from '@lib/api';
import { GoogleMapClusterMarker } from '@lib/geo/google/map';
import { COLORS } from '@lib/ui/theme';

export class FsAxonCameraClusterMarker extends GoogleMapClusterMarker {
  constructor(cluster: SnMapClusterPoint) {
    super(cluster, {
      icon: {
        fontSet: 'fs',
        fontIcon: 'ab3',
      },
      style: {
        fillColor: COLORS['base-800'],
        strokeColor: COLORS['grey-400'],
        strokeWeight: 1,
        scale: 1.4,
      },
    });
  }
}
